import { SeeMore } from './SeeMore';

export type { TypeSeeMoreProps } from './types';
export default SeeMore;
